import { Fragment } from "react";
import utils from "../services/appointment";
import { useContext as useAppContext } from "../store/useContext";

const SLOT_SIZE = 12;
const HOUR_ROW = 2;
const MINUTE_MARKERS = [
  { row: 6, value: 20 },
  { row: 10, value: 40 },
];
const LABEL_CLASS = "sticky left-0 z-20 -ml-14 w-14 pr-2 text-right";
const HOUR_CLASS = `${LABEL_CLASS} -mt-2.5 text-sm/5 text-gray-600`;
const MINUTE_CLASS = `${LABEL_CLASS} text-[14px] text-gray-500`;

export default function HoursDay({}, ref) {
  const minStartTime = useAppContext((state) => state.context.minStartTime);
  const maxEndTime = useAppContext((state) => state.context.maxEndTime);
  const { startHour, numHours } = utils.getHourRange(minStartTime, maxEndTime);

  const hours = Array.from({ length: numHours }, (_, i) => {
    const hour = (startHour + i) % 24; // asegura ciclo 0–23
    const period = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12} ${period}`;
  });

  return (
    <div
      ref={ref}
      className="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-200/70"
      style={{
        gridTemplateRows: `1.75rem repeat(${numHours * SLOT_SIZE}, minmax(0, 1fr)) auto`,
      }}
    >
      <div className="row-end-1 h-7" />

      {hours.map((hour, i) => {
        const baseRow = i * SLOT_SIZE;

        return (
          <Fragment key={hour}>
            <div style={{ gridRow: `${baseRow + HOUR_ROW} / span 1` }}>
              <div className={HOUR_CLASS}>{hour}</div>
            </div>

            {MINUTE_MARKERS.map(({ row, value }) => (
              <div key={value} style={{ gridRow: `${baseRow + row} / span 1` }}>
                <div className={MINUTE_CLASS}>{value}</div>
              </div>
            ))}
          </Fragment>
        );
      })}
    </div>
  );
}
